import { Link } from 'react-router-dom';
import { useModules } from '../hooks/useModules';

interface ModuleGateProps {
  module: string;
  children: React.ReactNode;
}

export default function ModuleGate({ module, children }: ModuleGateProps) {
  const { hasModule, loading } = useModules();

  if (loading) return null;

  if (!hasModule(module)) {
    return (
      <div style={{
        padding: 'calc(var(--nav-height) + 40px) 20px',
        maxWidth: 600,
        margin: '0 auto',
        textAlign: 'center',
      }}>
        <div style={{ fontSize: 48, marginBottom: 16, opacity: 0.3 }}>&#x1F512;</div>
        <h2 style={{ fontSize: 18, fontWeight: 600, marginBottom: 8 }}>Module Not Enabled</h2>
        <p style={{ fontSize: 14, color: 'var(--text-muted)', marginBottom: 20 }}>
          This module isn't enabled for your account.
          Contact your administrator to enable it.
        </p>
        <Link to="/" style={{ fontSize: 14, color: 'var(--accent)' }}>Back to Dashboard</Link>
      </div>
    );
  }

  return <>{children}</>;
}
